export interface AppConfig {
  production: boolean;
  baseURL: string;
  appURL?: string;
  webURL: string;
  assetsURL: string;
}
